var _style, _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIronOverload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6393D;}\n\t.st1{fill:#418133;}\n\t.st2{fill:#1A682F;}\n\t.st3{fill:#73B657;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:2.2575;stroke-linecap:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.3,183.2c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9s-77.6,34.4-77.6,76.9 C28.7,148.7,63.5,183.2,106.3,183.2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95,90.5c-2.3-3.4-6.7-16.8-15.8-14.3c-5.2,1.4-7.8,10.5-5.2,19.4c2.1,7,6.8,13,4.8,15.2 c-2,2.2-3.8,6.4,0.4,9.4c4.2,3,14.1,5.7,23.6,7.6c0,0,4.9-15.1,3.3-20C104.4,102.9,97.3,93.9,95,90.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M99.1,92.4c-0.9-1.3-1.7-2.4-2.3-3.1c-0.4-0.5-0.8-1.5-1.4-2.6c-2.5-4.9-6.6-13-14.1-13 c-0.9,0-1.9,0.1-2.9,0.4c-2.3,0.6-4.2,2.3-5.6,4.8c-2.5,4.5-2.9,11.2-1.1,17.4c0.9,2.9,2.1,5.6,3.2,7.9c0.9,1.8,2,4.3,2,5.2 c-1.9,2.1-2.9,4.8-2.6,7.2c0.2,1.5,0.9,3.7,3.5,5.5c5.3,3.7,17.6,6.6,24.5,7.9l2,0.4l0.6-1.9c0.9-2.6,5-16.1,3.3-21.5 C106.8,103,102.3,96.9,99.1,92.4z M101.2,125.2c-10.1-2.1-17.6-4.6-20.8-6.8c-1-0.7-1.5-1.4-1.6-2.3c-0.1-1.3,0.7-2.8,1.6-3.7 c2.3-2.5,0.6-6-1.3-10.1c-1-2.2-2.2-4.7-3-7.3c-1.5-5-1.2-10.5,0.7-13.9c0.6-1,1.5-2.3,2.9-2.7c0.6-0.2,1.1-0.2,1.6-0.2 c4.7,0,7.9,6.3,10,10.5c0.6,1.2,1.2,2.3,1.7,3.1c0.6,0.8,1.4,2,2.3,3.3c2.9,4,7.3,10,8.4,13.4 C104.7,111.1,102.9,119.2,101.2,125.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132.1,87.1c-6.2,3.3-12.1,14.9-14.3,18.4c0,0-2.9-3.1-3.9,2.2c-1,5.3,0,18.9-0.4,22.8c0,0,6.8-4.6,15.7-9.2 c8.6-4.4,8.7-11.3,10.4-22.4C141.2,87.7,138.3,83.8,132.1,87.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M131,85.1c-5.6,3-10.6,11.5-13.6,16.5c-0.2,0.3-0.3,0.6-0.5,0.8c-0.3-0.1-0.6-0.1-1-0.1 c-1.3,0-3.6,0.6-4.4,5c-0.6,3.5-0.5,9.9-0.4,15.6c0.1,3.1,0.1,6,0,7.4l-0.4,4.7l3.9-2.7c0.1,0,6.8-4.6,15.5-9 c8.9-4.6,9.8-11.5,11.2-21.2c0.1-0.9,0.3-1.9,0.4-2.9c1-6.7,0.4-11.2-1.7-13.6C138.1,83.3,134.8,83,131,85.1z M137.3,98.6 c-0.1,1-0.3,2-0.4,2.9c-1.3,9.2-2,14.3-8.7,17.8c-5.1,2.6-9.5,5.2-12.4,7c0-1.1,0-2.3-0.1-3.5c-0.1-5.2-0.2-11.6,0.3-14.7 c0.1-0.4,0.1-0.7,0.2-0.9l1.8,1.9l1.6-2.4c0.4-0.7,1-1.7,1.7-2.8c2.6-4.4,7.3-12.5,11.8-14.8c1.3-0.7,2.2-0.9,2.6-0.9 c0.5,0,0.7,0.2,0.9,0.4C137.1,89.1,138.4,91.2,137.3,98.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M85.9,90c-0.4-0.7-1.3-1-2.1-0.5c-0.7,0.4-1,1.3-0.5,2.1c0.2,0.4,23.5,39.9,23.2,59.9l0,11.2 c0,0.8,0.7,1.5,1.5,1.5c0.8,0,1.5-0.7,1.5-1.5l0-11.1C109.8,130.6,86.9,91.7,85.9,90z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M85,111.9c-0.8,0.2-1.4,0.9-1.2,1.8c0.2,0.8,0.9,1.3,1.8,1.2c0.1,0,9.2-1.6,11.2,2.8c0.2,0.6,0.8,0.9,1.4,0.9 c0.2,0,0.4,0,0.6-0.1c0.8-0.3,1.1-1.2,0.8-2C96.6,109.8,85.5,111.8,85,111.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M132.2,98.6c-0.7-0.5-1.6-0.3-2.1,0.4c-2.4,3.6-23.2,35.2-22.5,44.6l0.2,19.1c0,0.8,0.7,1.5,1.5,1.5 c0,0,0,0,0,0c0.8,0,1.5-0.7,1.5-1.5l-0.2-19.2c-0.5-7.2,15.7-33.3,22-42.8C133.1,100,132.9,99.1,132.2,98.6z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 105.8,
    y1: 54.3,
    x2: 105.8,
    y2: 43.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 88,
    y1: 57.4,
    x2: 84.3,
    y2: 47.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 72.3,
    y1: 66.5,
    x2: 65.4,
    y2: 58.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 60.6,
    y1: 80.4,
    x2: 51.4,
    y2: 75
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 54.4,
    y1: 97.4,
    x2: 43.9,
    y2: 95.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 54.4,
    y1: 115.5,
    x2: 43.9,
    y2: 117.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 157.2,
    y1: 115.5,
    x2: 167.7,
    y2: 117.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 157.2,
    y1: 97.4,
    x2: 167.7,
    y2: 95.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 151,
    y1: 80.4,
    x2: 160.3,
    y2: 75
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 139.3,
    y1: 66.5,
    x2: 146.2,
    y2: 58.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 123.7,
    y1: 57.4,
    x2: 127.3,
    y2: 47.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIronOverload);
export default __webpack_public_path__ + "static/media/Iron_Overload.69fdf577f0b55a0be09af3985ca73759.svg";
export { ForwardRef as ReactComponent };